<template>
  <b-modal :active.sync="isModalActive" scroll="keep" :canCancel="true" :onCancel="closeModal">
    <section>
      <article class="message is-primary">
        <div class="message-header">
          <p>バンドル作成</p>
        </div>
        <div class="message-body">
          <b-message type="is-warning">
            ※最大8モデルまで選択可能です
          </b-message>
          <template v-for="(group, index) in groups">
            <b-collapse class="card" :aria-id="index.toString()" :open.sync="group.open">
              <div
                slot="trigger"
                slot-scope="group"
                class="card-header"
                role="button"
                :aria-controls="index">
                <p class="card-header-title">性別 / 年齢 / 郵便番号 / 地域コード / 職業</p>
                <a class="card-header-icon">
                  <b-icon
                    :icon="group.open ? 'menu-down' : 'menu-up'">
                  </b-icon>
                </a>
              </div>
              <div class="card-content">
                <div class="content">
                  <template v-for="modelID in group.models">
                    <div class="field">
                      <b-tooltip :label="models[modelID].description"
                                 multilined
                                 position="is-right">
                        <b-checkbox v-model="bundleList" :native-value="modelID">
                          {{ models[modelID].display_name }}
                        </b-checkbox>
                      </b-tooltip>

                    </div>
                  </template>
                  <b-field label="バンドル名">
                    <b-input v-model="bundleName"></b-input>
                  </b-field>
                </div>
              </div>
              <footer class="card-footer">
                <a class="card-footer-item" @click="group.open = false">キャンセル</a>
                <a class="card-footer-item" @click="bundling(group)">作成</a>
              </footer>
            </b-collapse>
          </template>

        </div>
      </article>


    </section>
  </b-modal>
</template>

<script>

import {modelsRequest, bundlingRequest} from '../modules/request/models'

export default {
  name: 'BundlingModal',
  props: {
    isModalActive: {type: Boolean, default: false},
    transactionID: {type: String, default: ''}
  },
  data () {
    return {
      groups: [],
      models: {},
      bundleList: [],
      bundleName: ''
    }
  },
  watch: {
    bundleList () {
      if (this.bundleList.length > 8) {
        this.bundleList.pop()
        this.$toast.open({
          message: '最大8モデルまでが選択可能です',
          type: 'is-warning'
        })
      }
    },
    async isModalActive () {
      if (this.isModalActive && this.groups.length === 0) {
        let $parent = this.$parent
        $parent.loading.isActive = true

        let response = await modelsRequest($parent, {grouping: 'inputs'})

        if (response.groups.length === 1) {
          response.groups[0]['open'] = true
        } else {
          for (let i in response.groups) {
            response.groups[i]['open'] = false
          }
        }

        this.groups = response.groups
        this.models = response.models
      }
    }
  },
  methods: {
    async bundling (group) {

      if (this.bundleList.length < 1) {
        this.$toast.open({
          message: '2モデル以上を選択してください',
          type: 'is-warning'
        })
        return false
      }

      if (!this.bundleName) {
        this.$toast.open({
          message: 'バンドル名を入力してください',
          type: 'is-warning'
        })
        return false
      }

      this.$parent.loading.isActive = true

      let param = {
        'bundle_name': this.bundleName,
        'bundled_models': this.bundleList
      }

      await bundlingRequest(this, param)

      group.open = false
      this.bundleName = ''
      this.bundleList = []
      this.$parent.loading.isActive = false
      this.closeModal()

      this.$snackbar.open({
        duration: 3000,
        message: 'バンドルが作成されました',
        type: 'is-success',
        position: 'is-top',
        actionText: 'OK',
        queue: false,
        onAction: () => {
        }
      })

      this.$parent.getModels()
    },
    closeModal () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BundlingModal.vue